








































































import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class WQtypeCheckboxView extends BaseComponent {
	@Prop({ type: Object, required: true })
	options!: any;
	@Prop()
	injectedAnswer!: any;
	@Prop()
	injectedStats!: any;
	@Prop({ type: Boolean, default: false })
	lock!: boolean;

	answerValue = (this.injectedAnswer || { value: [] }).value;
	othersValue = (this.injectedAnswer || { othersValue: "" }).othersValue;

	get form() {
		return {
			fields: {
				answer: {
					field: "checkbox"
				}
			}
		};
	}
	stats(uuid: string) {
		if (this.injectedStats) {
			let choiceStats = this.injectedStats.choices[uuid],
				total = this.injectedStats.questionAnswersCount,
				count = choiceStats.count,
				percent =
					parseInt(String((count / (total || 1)) * 10000)) / 100;

			return {
				total,
				count,
				percent
			};
		}
		return {};
	}

	get showOthersField() {
		let v: any = this.options.othersChoiceUuid;

		return this.answerValue.indexOf(v as never) >= 0;
	}

	@Watch("answerValue")
	watchAnswerValue() {
		this.onAnswerChange();
	}

	@Watch("othersValue")
	watchOthersValue() {
		this.onAnswerChange();
	}

	@Emit("type-answer-change")
	onAnswerChange() {
		let min = this.options.min,
			max = this.options.max,
			len = this.answerValue.length,
			valid = true,
			others = this.showOthersField;

		if (len) {
			valid = min <= len && (max ? len <= max : true);
		}

		if (others && !this.othersValue.length) {
			valid = false;
		}

		return {
			othersValue: others ? this.othersValue : "",
			value: this.answerValue,
			isValid: valid,
			isEmpty: !len
		};
	}

	mounted() {
		this.onAnswerChange();
	}
}
